import React, { useState, useRef, useEffect } from "react";

import "./accordion.scss";

function Accordion(props) {
  const { title, isActive, isPhaseValidate, onPhaseToggle } = props;
  const [height, setHeight] = useState("0px");

  const content = useRef(null);

  useEffect(() => {
    if (isActive) {
      setHeight(`${content.current.scrollHeight + 50}px`);
    }
  }, []);

  function toggleAccordion() {
    onPhaseToggle();
    setHeight(isActive ? "0px" : `${content.current.scrollHeight + 50}px`);
  }

  useEffect(() => {
    setTimeout(() => {
      if (height && height !== "0px") {
        document
          ?.getElementsByClassName("accordion__content--active")[0]
          ?.parentElement?.scrollIntoView({
            behavior: "smooth",
          });
      }
    }, 500);
  }, [height]);

  return (
    <div className="accordion">
      <button
        className={`accordion__header ${
          isActive ? "accordion__header--active" : ""
        }`}
        onClick={toggleAccordion}
      >
        <p className={`accordion__title ${isPhaseValidate ? "accordion__title--validate" : ""}`}>{title}</p>
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${isActive ? height : "0px"}` }}
        className={`accordion__content ${
          isActive ? "accordion__content--active" : ""
        }`}
      >
        {/* <div className="accordion__text"> */}
        {props.content}
        {/* </div> */}
      </div>
    </div>
  );
}

export default Accordion;
